import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineClipboardNotesIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M13 14H9a1.0002 1.0002 0 0 0-.7071 1.7071C8.4804 15.8946 8.7348 16 9 16h4a1.0001 1.0001 0 0 0 0-2Zm4-10h-1.18A3.0002 3.0002 0 0 0 13 2h-2a3.0001 3.0001 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3Zm-7 1a1.0002 1.0002 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4V5Zm8 14a1.0001 1.0001 0 0 1-1 1H7a1.0002 1.0002 0 0 1-1-1V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1v12Zm-3-9H9a1.0002 1.0002 0 0 0-.7071 1.7071C8.4804 11.8946 8.7348 12 9 12h6a1.0001 1.0001 0 0 0 0-2Z"/>
  </SvgIcon>
}

export default LineClipboardNotesIcon
